"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Eyepatch_1 = __importDefault(require("./Eyepatch"));
var Hat_1 = __importDefault(require("./Hat"));
var Hijab_1 = __importDefault(require("./Hijab"));
var LongHairBigHair_1 = __importDefault(require("./LongHairBigHair"));
var LongHairBob_1 = __importDefault(require("./LongHairBob"));
var LongHairBun_1 = __importDefault(require("./LongHairBun"));
var LongHairCurly_1 = __importDefault(require("./LongHairCurly"));
var LongHairCurvy_1 = __importDefault(require("./LongHairCurvy"));
var LongHairDreads_1 = __importDefault(require("./LongHairDreads"));
var LongHairFrida_1 = __importDefault(require("./LongHairFrida"));
var LongHairFro_1 = __importDefault(require("./LongHairFro"));
var LongHairFroBand_1 = __importDefault(require("./LongHairFroBand"));
var LongHairMiaWallace_1 = __importDefault(require("./LongHairMiaWallace"));
var LongHairNotTooLong_1 = __importDefault(require("./LongHairNotTooLong"));
var LongHairShavedSides_1 = __importDefault(require("./LongHairShavedSides"));
var LongHairStraight_1 = __importDefault(require("./LongHairStraight"));
var LongHairStraight2_1 = __importDefault(require("./LongHairStraight2"));
var LongHairStraightStrand_1 = __importDefault(require("./LongHairStraightStrand"));
var NoHair_1 = __importDefault(require("./NoHair"));
var ShortHairDreads01_1 = __importDefault(require("./ShortHairDreads01"));
var ShortHairDreads02_1 = __importDefault(require("./ShortHairDreads02"));
var ShortHairFrizzle_1 = __importDefault(require("./ShortHairFrizzle"));
var ShortHairShaggyMullet_1 = __importDefault(require("./ShortHairShaggyMullet"));
var ShortHairShortCurly_1 = __importDefault(require("./ShortHairShortCurly"));
var ShortHairShortFlat_1 = __importDefault(require("./ShortHairShortFlat"));
var ShortHairShortRound_1 = __importDefault(require("./ShortHairShortRound"));
var ShortHairShortWaved_1 = __importDefault(require("./ShortHairShortWaved"));
var ShortHairSides_1 = __importDefault(require("./ShortHairSides"));
var ShortHairTheCaesar_1 = __importDefault(require("./ShortHairTheCaesar"));
var ShortHairTheCaesarSidePart_1 = __importDefault(require("./ShortHairTheCaesarSidePart"));
var Turban_1 = __importDefault(require("./Turban"));
var WinterHat1_1 = __importDefault(require("./WinterHat1"));
var WinterHat2_1 = __importDefault(require("./WinterHat2"));
var WinterHat3_1 = __importDefault(require("./WinterHat3"));
var WinterHat4_1 = __importDefault(require("./WinterHat4"));
var react_1 = require("react");
var AvatarContext_1 = __importDefault(require("../AvatarContext"));
var TopType_1 = __importDefault(require("./TopType"));
var Top = function (_a) {
    var _b;
    var children = _a.children;
    var type = (_b = react_1.useContext(AvatarContext_1.default).topType) !== null && _b !== void 0 ? _b : TopType_1.default.LongHairStraight;
    switch (type) {
        case TopType_1.default.NoHair:
            return jsx_runtime_1.jsx(NoHair_1.default, { children: children }, void 0);
        case TopType_1.default.Eyepatch:
            return jsx_runtime_1.jsx(Eyepatch_1.default, {}, void 0);
        case TopType_1.default.Hat:
            return jsx_runtime_1.jsx(Hat_1.default, { children: children }, void 0);
        case TopType_1.default.Hijab:
            return jsx_runtime_1.jsx(Hijab_1.default, { children: children }, void 0);
        case TopType_1.default.Turban:
            return jsx_runtime_1.jsx(Turban_1.default, { children: children }, void 0);
        case TopType_1.default.WinterHat1:
            return jsx_runtime_1.jsx(WinterHat1_1.default, { children: children }, void 0);
        case TopType_1.default.WinterHat2:
            return jsx_runtime_1.jsx(WinterHat2_1.default, { children: children }, void 0);
        case TopType_1.default.WinterHat3:
            return jsx_runtime_1.jsx(WinterHat3_1.default, { children: children }, void 0);
        case TopType_1.default.WinterHat4:
            return jsx_runtime_1.jsx(WinterHat4_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairBigHair:
            return jsx_runtime_1.jsx(LongHairBigHair_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairBob:
            return jsx_runtime_1.jsx(LongHairBob_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairBun:
            return jsx_runtime_1.jsx(LongHairBun_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairCurly:
            return jsx_runtime_1.jsx(LongHairCurly_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairCurvy:
            return jsx_runtime_1.jsx(LongHairCurvy_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairDreads:
            return jsx_runtime_1.jsx(LongHairDreads_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairFrida:
            return jsx_runtime_1.jsx(LongHairFrida_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairFro:
            return jsx_runtime_1.jsx(LongHairFro_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairFroBand:
            return jsx_runtime_1.jsx(LongHairFroBand_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairNotTooLong:
            return jsx_runtime_1.jsx(LongHairNotTooLong_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairShavedSides:
            return jsx_runtime_1.jsx(LongHairShavedSides_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairMiaWallace:
            return jsx_runtime_1.jsx(LongHairMiaWallace_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairStraight:
            return jsx_runtime_1.jsx(LongHairStraight_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairStraight2:
            return jsx_runtime_1.jsx(LongHairStraight2_1.default, { children: children }, void 0);
        case TopType_1.default.LongHairStraightStrand:
            return jsx_runtime_1.jsx(LongHairStraightStrand_1.default, { children: children }, void 0);
        case TopType_1.default.ShortHairDreads01:
            return jsx_runtime_1.jsx(ShortHairDreads01_1.default, { children: children }, void 0);
        case TopType_1.default.ShortHairDreads02:
            return jsx_runtime_1.jsx(ShortHairDreads02_1.default, { children: children }, void 0);
        case TopType_1.default.ShortHairFrizzle:
            return jsx_runtime_1.jsx(ShortHairFrizzle_1.default, { children: children }, void 0);
        /* XXX: broken, fix it later
        case TopType.ShortHairShaggy:
          return <ShortHairShaggy>{children}</ShortHairShaggy>*/
        case TopType_1.default.ShortHairShaggyMullet:
            return jsx_runtime_1.jsx(ShortHairShaggyMullet_1.default, { children: children }, void 0);
        case TopType_1.default.ShortHairShortCurly:
            return jsx_runtime_1.jsx(ShortHairShortCurly_1.default, { children: children }, void 0);
        case TopType_1.default.ShortHairShortFlat:
            return jsx_runtime_1.jsx(ShortHairShortFlat_1.default, { children: children }, void 0);
        case TopType_1.default.ShortHairShortRound:
            return jsx_runtime_1.jsx(ShortHairShortRound_1.default, { children: children }, void 0);
        case TopType_1.default.ShortHairShortWaved:
            return jsx_runtime_1.jsx(ShortHairShortWaved_1.default, { children: children }, void 0);
        case TopType_1.default.ShortHairSides:
            return jsx_runtime_1.jsx(ShortHairSides_1.default, { children: children }, void 0);
        case TopType_1.default.ShortHairTheCaesar:
            return jsx_runtime_1.jsx(ShortHairTheCaesar_1.default, { children: children }, void 0);
        case TopType_1.default.ShortHairTheCaesarSidePart:
            return jsx_runtime_1.jsx(ShortHairTheCaesarSidePart_1.default, { children: children }, void 0);
    }
};
exports.default = Top;
